import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isFetching: false,
    data: [],
    count: 0,
    searchCount: null,
    searchKeys: [],
    error: null,
}

const logsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_LOGS_REQUEST:
    case ActionTypes.FETCH_LOGS_COUNT_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: action.payload,
      };
    case ActionTypes.FETCH_LOGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data_list,
        count: action.payload.all_data_count,
        error: action.payload,
      };
    case ActionTypes.FETCH_LOGS_COUNT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        searchCount: action.payload.count,
        searchKeys: action.payload.keys,
        error: action.payload,
      };
    case ActionTypes.FETCH_LOGS_FAILURE:
    case ActionTypes.FETCH_LOGS_COUNT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default logsReducer;